
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("e14IX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4T4vf = parcelRequire("4T4vf");


var $luv00 = parcelRequire("luv00");

const $ffaacbf4faa73d50$export$ed7a1c0e36312b6a = 'is-dragging-tree-item';


function $83aac7cff8f4987b$export$e5989385da3155c8({ setIsDraggingItem: setIsDraggingItem, itemType: itemType = 'tree-item' }) {
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    (0, $42omo.useEffect)(()=>{
        return (0, $4T4vf.monitorForElements)({
            canMonitor: ({ source: source })=>source.data.type === itemType,
            onGenerateDragPreview: ()=>{
                setIsDraggingItem?.(true);
                document.body.classList.add((0, $ffaacbf4faa73d50$export$ed7a1c0e36312b6a));
            },
            onDrop: ()=>{
                setIsDraggingItem?.(false);
                document.body.classList.remove((0, $ffaacbf4faa73d50$export$ed7a1c0e36312b6a));
            }
        });
    }, [
        setIsDraggingItem,
        itemType
    ]);
    // Safety: removing the dragging class from the body if the component is unmounted
    (0, $42omo.useEffect)(function mount() {
        return function unmount() {
            document.body.classList.remove((0, $ffaacbf4faa73d50$export$ed7a1c0e36312b6a));
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "tree-monitor",
        "data-vc": "tree-monitor",
        ...ssrPlaceholderIdProp
    });
}
module.exports["TreeMonitor"] = $83aac7cff8f4987b$export$e5989385da3155c8;

});

parcelRegister("luv00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});


//# sourceMappingURL=TreeMonitor.fca94b1c.js.map
